import FormGroup from "features/shared/forms/components/FormGroup";
import { UseFormHookResult } from "features/shared/forms/hooks/useForm";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  formHandler: UseFormHookResult;
  objectPrefix: string;
  disabled?: boolean;
};

const CadastralInfoSubForm = ({ formHandler, objectPrefix, disabled }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // form hook props
  const { bindField, errors } = {
    ...formHandler,
  };

  // helpers
  const getInputName = (name: string) => {
    return `${objectPrefix}.${name}`;
  };

  // render
  return (
    <div className="row no-gutters mx-n2">
      <div className="col-sm-6 px-2">
        <FormGroup
          labelText={tLabels("cadastralInfoSubForm.cadastralTerritory.label")}
          inputId={getInputName("cadastralTerritory")}
          validationError={errors[getInputName("cadastralTerritory")]}
        >
          <input
            id={getInputName("cadastralTerritory")}
            className="form-control"
            placeholder={tLabels("cadastralInfoSubForm.cadastralTerritory.placeholder")}
            {...bindField(getInputName("cadastralTerritory"))}
            disabled={disabled}
          />
        </FormGroup>
      </div>
      <div className="col-sm-6 px-2">
        <FormGroup
          labelText={tLabels("cadastralInfoSubForm.parcelNumber.label")}
          inputId={getInputName("parcelNumber")}
          validationError={errors[getInputName("parcelNumber")]}
        >
          <input
            id={getInputName("parcelNumber")}
            className="form-control"
            placeholder={tLabels("cadastralInfoSubForm.parcelNumber.placeholder")}
            {...bindField(getInputName("parcelNumber"))}
            disabled={disabled}
          />
        </FormGroup>
      </div>
      <div className="col-sm-6 px-2">
        <FormGroup
          labelText={tLabels("cadastralInfoSubForm.city.label")}
          inputId={getInputName("city")}
          validationError={errors[getInputName("city")]}
        >
          <input
            id={getInputName("city")}
            className="form-control"
            placeholder={tLabels("cadastralInfoSubForm.city.placeholder")}
            {...bindField(getInputName("city"))}
            disabled={disabled}
          />
        </FormGroup>
      </div>
      <div className="col-sm-6 px-2">
        <FormGroup
          labelText={tLabels("cadastralInfoSubForm.cityPart.label")}
          inputId={getInputName("cityPart")}
          validationError={errors[getInputName("cityPart")]}
        >
          <input
            id={getInputName("cityPart")}
            className="form-control"
            placeholder={tLabels("cadastralInfoSubForm.cityPart.placeholder")}
            {...bindField(getInputName("cityPart"))}
            disabled={disabled}
          />
        </FormGroup>
      </div>
      <div className="col-sm-6 px-2">
        <FormGroup
          labelText={tLabels("cadastralInfoSubForm.zipCode.label")}
          inputId={getInputName("zipCode")}
          validationError={errors[getInputName("zipCode")]}
        >
          <input
            id={getInputName("zipCode")}
            className="form-control"
            placeholder={tLabels("cadastralInfoSubForm.zipCode.placeholder")}
            {...bindField(getInputName("zipCode"))}
            disabled={disabled}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default CadastralInfoSubForm;
